@if (!!filmInventory) {
  <div class="inline-block">Lagerplatz Film:&nbsp;</div>
  <div class="inline-block bold inventory-highlight">{{filmInventory}}</div>
}
